import { APIManager } from "shared/manager";
import { RestEnds } from "../shared/Constants";
import AxiosManager from "shared/manager/AxiosManager";

const getAllStakeholders = async (loanId) => {
  return APIManager.sendGet(
    `${RestEnds.STAKEHOLDERS}?limit=10&offset=1&loanId=${loanId}`,
    AxiosManager,
    true,
    {},
    {}
  );
};

const addStakeholders = async (data) => {
  return APIManager.sendPost(
    `${RestEnds.STAKEHOLDERS}`,
    AxiosManager,
    data,
    true,
    {},
    {}
  );
};

const updateStakeholders = async (loanId, stakeholderId, data) => {
  return APIManager.sendPatch(
    `${RestEnds.STAKEHOLDERS}/${loanId}/${stakeholderId}`,
    AxiosManager,
    data,
    true,
    {},
    {}
  );
};

const deleteStakeholders = async (loanId, stakeholderId) => {
  return APIManager.sendDelete(
    `${RestEnds.STAKEHOLDERS}/${loanId}/${stakeholderId}`,
    AxiosManager,
    true,
    {},
    {}
  );
};

export const StakeholderService = {
  getAllStakeholders,
  addStakeholders,
  deleteStakeholders,
  updateStakeholders,
};
